function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clock_svg__clip0_925_1888)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 5v5l3.333 1.667m5-1.667a8.333 8.333 0 11-16.667 0 8.333 8.333 0 0116.667 0z",
  stroke: "#fff",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clock_svg__clip0_925_1888"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF85MjVfMTg4OCkiPg0KPHBhdGggZD0iTTkuOTk5ODQgNS4wMDAzM1YxMC4wMDAzTDEzLjMzMzIgMTEuNjY3TTE4LjMzMzIgMTAuMDAwM0MxOC4zMzMyIDE0LjYwMjcgMTQuNjAyMiAxOC4zMzM3IDkuOTk5ODQgMTguMzMzN0M1LjM5NzQ2IDE4LjMzMzcgMS42NjY1IDE0LjYwMjcgMS42NjY1IDEwLjAwMDNDMS42NjY1IDUuMzk3OTUgNS4zOTc0NiAxLjY2Njk5IDkuOTk5ODQgMS42NjY5OUMxNC42MDIyIDEuNjY2OTkgMTguMzMzMiA1LjM5Nzk1IDE4LjMzMzIgMTAuMDAwM1oiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS43NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L2c+DQo8ZGVmcz4NCjxjbGlwUGF0aCBpZD0iY2xpcDBfOTI1XzE4ODgiPg0KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIvPg0KPC9jbGlwUGF0aD4NCjwvZGVmcz4NCjwvc3ZnPg0K";
export { SvgClock as ReactComponent };